export default class DropDown {
  constructor(dropDown, select, btn) {
    this._dropDown = dropDown;
    this._dropDownItems = Array.from(this._dropDown.querySelectorAll(`.js-drop-down-item`));
    this._select = select;
    this._btn = btn;
    this._btnValue = this._btn.querySelector(`.js-drop-down-value`);

    this._selectChangeHandler = this._selectChangeHandler.bind(this);
    this._btnClickHandler = this._btnClickHandler.bind(this);
    this._dropDownItemClickHandler = this._dropDownItemClickHandler.bind(this);
    this._documentClickHandler = this._documentClickHandler.bind(this);
    this._windowResizeHandler = this._windowResizeHandler.bind(this);

    this.init();
  }

  _setCssProps() {
    this._dropDown.style.setProperty(
        `--reports-top`,
        `${this._btn.offsetTop + this._btn.offsetHeight}px`
    );
    this._dropDown.style.setProperty(
        `--reports-left`,
        `${this._btn.offsetLeft + this._btn.offsetWidth / 2}px`
    );
  }

  _selectChangeHandler(evt) {

    this._updateYears(evt.currentTarget, this._select.querySelectorAll("option")[evt.currentTarget.selectedIndex].dataset.year);

    const options = this._select.querySelectorAll(`option`);
    options.forEach((opt, i) => {
      if (i === evt.currentTarget.selectedIndex) {
        opt.disabled = true;
      } else {
        opt.disabled = false;
      }
    })
  }

  _btnClickHandler(evt) {

    this._setCssProps();

    evt.stopPropagation();
    this._dropDown.classList.toggle(`active`);

    this._dropDownItems.forEach((item) => {
      item.addEventListener(`click`, this._dropDownItemClickHandler);
    })

    document.addEventListener(`click`, this._documentClickHandler);
  }

  _dropDownItemClickHandler(evt) {

    this._updateBtn(evt.currentTarget);
    this._toggleActiveItem();
    this._updateYears(evt.currentTarget);
  }

  _documentClickHandler(evt) {
    if (!evt.target.classList.contains(`js-drop-down`)) {
      this._dropDown.classList.remove(`active`);

      this._dropDownItems.forEach((item) => {
        item.removeEventListener(`click`, this._dropDownItemClickHandler);
      })

      document.removeEventListener(`click`, this._documentClickHandler);
    }
  }

  _toggleActiveItem() {
    this._dropDownItems.forEach((item) => {
      if (item.dataset.year === this._btn.dataset.year) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });
  }

  _updateYears(item, year) {
    var year = year ? year : this._btn.dataset.year;
    var tab = this._btn.dataset.tab === undefined ? 'tab1' : this._btn.dataset.tab;
    var childElements = document.querySelector(".js-tabs-container-years." + tab).querySelectorAll(".js-tabs-block-years");
    if(year === undefined) {
      childElements[0].classList.add("active");
    }
    else {
      childElements.forEach((function (elem, number) {
        if (elem.dataset.year == year) {
          elem.classList.add("active");
        } else {
          elem.classList.remove("active");
        }
      }));
    }
  }

  _updateBtn(item) {
    this._btnValue.textContent = item.textContent;
    this._btn.dataset.year = item.dataset.year;
  }

  _windowResizeHandler() {
    this._setCssProps();
  }

  init() {
    const activeItem = this._toggleActiveItem();
    if (activeItem) {
      this._updateBtn(activeItem);
    }

    const activeYears = this._updateYears();

    this._setCssProps();

    this._select.addEventListener(`change`, this._selectChangeHandler);
    this._btn.addEventListener(`click`, this._btnClickHandler);
    window.addEventListener(`resize`, this._windowResizeHandler);
  }
}
